import LegalPage from "../components/LegalPage";
import { refundPolicyContent } from "../data/legalContent";

const RefundPolicyPage = () => {
  return <LegalPage pageTestId="refund-policy-page" {...refundPolicyContent} />;
};

export default RefundPolicyPage;
